import { render, staticRenderFns } from "./chooseAccessory.vue?vue&type=template&id=308b1006&"
import script from "./chooseAccessory.vue?vue&type=script&lang=js&"
export * from "./chooseAccessory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports